<template>
    <div class="py-3 styleInIPad">
        <div class="mb-3">
            <router-link class="back-route h3" ref="backBtn" @click="backHandler" :to="isFull ? '#':'/create-competitions'">
                <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                {{competition.name}}
            </router-link>
        </div>
        <div class="mx-3">
            <p>{{templateName}} &nbsp;&nbsp
                <router-link :to="'/templates/view/'+template_id_view" v-if="permissions.includes('viewAny template')" class="linkViewTemplate">
                    View Template
                </router-link>
            </p>
        </div>
    </div>

    <div id="createUserContainer" class="tabcontent1">
        <div class="firstStartDate" v-if="competition.start_date != null">
            <h4>Start Date</h4>
            <h6>{{competition.start_date}}</h6>
        </div>
        <div class="firstStartDate" v-else>
            <h4>Start Date</h4>
            <h6>Not Choosen</h6>
        </div>

        <div class="secondEndDate" v-if="competition.end_date != null">
            <h4>End Date</h4>
            <h6>{{competition.end_date}}</h6>
        </div>
        <div class="secondEndDate" v-else>
              <h4>End Date</h4>
              <h6>Not Choosen</h6>
        </div>

        <div class="startTimeCss" v-if="competition.start_time != null">
            <h4>Start Time</h4>
            <h6>{{competition.start_time}} GMT</h6>
        </div>
        <div class="startTimeCss" v-else>
            <h4>Start Time</h4>
            <h6>Not Choosen</h6>
        </div>

        <div class="startTimeCss" v-if="competition.end_time != null">
            <h4>End Time</h4>
            <h6>{{competition.end_time}} GMT</h6>
        </div>
        <div class="startTimeCss" v-else>
             <h4>Start Time</h4>
              <h6>Not Choosen</h6>
        </div>

        <div class="durationCss" v-if="competition.duration != null">
            <h4>Duration</h4>
            <h6>{{competition.duration}} minutes</h6>
        </div>
        <div class="durationCss" v-else>
            <h4>Duration</h4>
            <h6>{{durationInTime}} minutes</h6>
        </div>

        <div class="cssActionsStyle">
<!--            <font-awesome-icon  :icon="['fas', 'trash']" class="trashDesign" v-if="permissions.includes('delete competition')" @click.prevent="deleteCompetition"  size="xl"/>-->
                &nbsp;&nbsp;&nbsp;&nbsp;
<!--            <font-awesome-icon :icon="['fas', 'pen']" class="penDesign" size="xl" @click.prevent="EditCompetition"/>-->
        </div>
    </div>

    <div id="createUserContainer2" class="d-flex justify-content-center">
        <div class="assignUsersCss">
            <div class="text-center mb-4">
                <img src="../../../assets/images/surface1.svg" alt="" >
            </div>
            <div class="text-center mb-4">
                <h5>No Users or Teams Are Assigned for This Competitions</h5>
            </div>
            <div class="buttonCssAssign text-center">
                <button @click="AssignUserToCompetition">Assign</button>
            </div>
        </div>
    </div>


    <AssignUsers @clickAssign="clickAssignHandler" v-if="this.isShow" :participant="participant_type_data" :training_type="training_type" :message="confirmMessage" :confirmUsers="ChooseUsers" :confirmTeam="ChooseTeam"
                 @close-modal="this.isShow = false"
                 :confirmTeamLeader="ChooseTeamLeader"/>

    <AssignTeamLeader v-if="isShow2" @close-modal="closeModalCompetition"  @success="ShowModalSuccess" :whoPlay="whoPlay" :participant="participant_type_data" :training_type="training_type"  :message="confirmMessage" :confirmUsers="ChooseUsers" :confirmTeam="ChooseTeam" />

    <ModalChooseUser @close-modal="closeModalHandler" :participant="participant_type_data" :training_type="training_type" v-if="this.isAssignFlag"  :message="chooseMessageText" :AssignUsers="AssignUsers" :data="data" @assignUsers1="AssignData1" @assignUsers2="AssignData2"/>

    <ConfirmationModal v-if="confirmModalFlag2" :message="confirmMessage" confirmBtn="Delete" cancleBtn="Cancel"
                       @close-modal="confirmModalHandler($event)"/>

    <ConfirmationModal v-if="confirmModalFlag3" :message="confirmMessage2" :id="competition_user_id" confirmBtn="Delete" cancleBtn="Cancel"
                       @close-modal="confirmModalHandler2($event)"/>

    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>

</template>

<script>
    import AssignUsers from '../../components/AssignUsers';
    import AssignTeamLeader from '../../components/AssignTeamLeader';
    import AlartModal from '../../components/AlartModal';
    import ModalChooseUser from '../../components/ModalChooseUsers';
    import competition from "../../../api-services/competition";
    import ConfirmationModal from "../../components/ConfirmationModal";
    import {computed} from "vue";
    import moment from 'moment';

    export default {
        name:'complete-competition',
        props:['ChooseUsers' , 'ChooseTeam' , 'ChooseTeamLeader' , 'AssignUsers'],
        data(){
            return {
                isFull:false,
                isShow:false,
                permissions:[],
                isShow2:false,
                showModal:false,
                message:'',
                ImagePath:'',
                isAssignFlag: false,
                confirmModalFlag: false,
                confirmModalFlag2: false,
                confirmModalFlag3: false,
                data: [],
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{

                },
                competition:{
                    name:null,
                    template_id:null,
                    type:null,
                    start_date:null,
                    end_date:null,
                    start_time:null,
                    end_time:null,
                    duration:null
                },
                durationInTime:null,
                templateName:'',
                template_id_view:null,
                confirmMessage: '',
                chooseMessageText:'',
                participant_type_data:null,
                training_type:null,
                whoPlay:null
            }
        },
        components:{
            AssignUsers,
            ModalChooseUser,
            ConfirmationModal,
            AlartModal,
            AssignTeamLeader
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'competition');
            this.permissions = this.$store.state.auth.permissions;
            this.getCompetition();
            const compData = await competition.show(this.$route.params.id);
            this.participant_type_data = compData.data.data.participant_type;
            this.whoPlay = compData.data.data.is_play;
        },
        methods:{
            ShowModalSuccess(){
                this.isShow2 = false;
                this.showModal = true;
                this.ImagePath = 'okImage.svg';
                this.message = "Users Assigned Successfully";
                window.location.href="/competitions";
            },
            closeModalHandler(e){
                this.isShow = false;
                this.isAssignFlag = false
            },
            clickAssignHandler(event){
                this.isAssignFlag = true;
                this.data = event[1].data.data;
                this.chooseMessageText = event[0];
            },
           async AssignData1(){
               this.isAssignFlag = false;
               this.isShow = false;
               this.showModal = true;
               this.ImagePath = 'okImage.svg';
               this.message = "Users Assigned Successfully";
               window.location.href = "/competitions";
            },

            async AssignData2(){
                this.isAssignFlag = false;
                this.isShow = false;
                this.isShow2 = true;
            },

            async backHandler () {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if(setDataFlag){
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                }else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            async confirmModalHandler (event) {
                // await this.$store.dispatch('setConfirmModal', false);
                this.confirmModalFlag2 = false;
                if(event){
                    // console.log(event);
                    const competition_id = this.$route.params.id;
                    await competition.delete(competition_id);
                    // await this.$store.dispatch('setDataFlag', false);
                    this.confirmModalFlag2 = false;
                    await this.$router.push('/competitions');
                }
            },
            AssignUserToCompetition(){
                this.isShow = true;
                this.confirmModalFlag = true;
                this.confirmMessage = 'Assign to';
            },
            async closeModalCompetition(){
                const competition_id = this.$route.params.id;
                await competition.deleteCompetitionUsers(competition_id);
                this.isShow2 = false;
            },
            async getCompetition(){
                const competition_id = this.$route.params.id;
                // console.log(competition_id);
                try{
                    const response = await competition.show(competition_id);

                    this.competition.name = response.data.data.name.charAt(0).toUpperCase() +  response.data.data.name.slice(1);
                    this.competition.template_id = response.data.data.template_id;
                    this.competition.start_date = moment(response.data.data.start_date).format('D-MMM-YYYY');
                    this.competition.end_date = moment(response.data.data.end_date).format('D-MMM-YYYY');
                    this.competition.start_time = response.data.data.start_time.slice(0,5);
                    this.competition.end_time = response.data.data.end_time.slice(0,5);
                    this.competition.duration = response.data.data.duration;
                    this.templateName = response.data.data.template.name;

                    if(this.competition.duration === null){
                        let startTime = moment(this.competition.start_time, "HH:mm:ss a");
                        let endTime = moment(this.competition.end_time, "HH:mm:ss a");
                        let duration  = moment.duration(endTime.diff(startTime));
                        let hours = parseInt(duration.asHours()) * 60;
                        let minutes = parseInt(duration.asMinutes()) % 60;

                        this.durationInTime = (hours+minutes);
                    }

                    this.template_id_view = response.data.data.template.id;
                }catch(e) {
                    // console.log(e);
                }
            },
            deleteCompetition(){
                this.confirmModalFlag2 = true;
                this.confirmMessage = 'Do you want to delete this competition?';
            },
            EditCompetition(){
                const competition_id = this.$route.params.id;
                this.$router.push({path: "/edit-competitions/"+competition_id});
            }
        }
    }
</script>

<style scoped>
    .styleInIPad{
        margin-bottom: 3rem;
    }
    .buttonCssAssign button{
        border:none;
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        padding: 10px 70px;
        border-radius: 5px;
    }
    .penDesign {
        color: #00970A;
        cursor: pointer;
    }
    .trashDesign {
        color: #FF7171;
        cursor: pointer;
    }
    .cssActionsStyle{
        width: 370px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .firstStartDate{
        width:370px;
    }
    .secondEndDate{
        width:370px;
    }
    .startTimeCss{
        width:370px;
    }
    .durationCss{
        width:370px;
    }
    .linkViewTemplate{
        color:#e65c00;
    }
    .assignUsersCss{
        width:700px;
        padding: 30px;
        height: 25vh;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 15px;
    }
    .tabcontent1{
        display: flex;
        padding: 30px;
        height: 15vh;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 15px;
        margin-bottom: 5rem;
    }

    @media only screen and (max-width: 1300px) and (min-width: 1250px) {
        .styleInIPad{
            margin-bottom: 0px;
        }
        .tabcontent1{
            height: 21vh;
            margin-bottom: 2rem;
        }
        .assignUsersCss{
            height: 33%;
        }
    }
</style>